/**
 * Castle & Key Product Carousel
 * Infinite-scroll bottle carousel — reorders DOM nodes after each slide
 * so there are always bottles on both sides of the active one.
 */
(function () {
  var carousel = document.querySelector('[data-ck-product-carousel]');
  if (!carousel) return;

  var track = carousel.querySelector('[data-carousel-track]');
  var prevBtn = carousel.querySelector('[data-carousel-prev]');
  var nextBtn = carousel.querySelector('[data-carousel-next]');
  var infoEl = carousel.querySelector('[data-carousel-info]');
  var categoryEl = carousel.querySelector('[data-carousel-category]');
  var titleEl = carousel.querySelector('[data-carousel-title]');
  var descriptionEl = carousel.querySelector('[data-carousel-description]');
  var awardsEl = carousel.querySelector('[data-carousel-awards]');
  var ctaEl = carousel.querySelector('.ck-spirits__cta');

  var bottles = function () {
    return Array.from(track.querySelectorAll('.ck-spirits__bottle'));
  };

  if (bottles().length === 0) return;

  var count = bottles().length;
  var isAnimating = false;
  // activeIndex tracks which DOM child is active (always kept near center)
  var activeIndex = 0;
  bottles().forEach(function (b, i) {
    if (b.classList.contains('is-active')) activeIndex = i;
  });

  /**
   * Balance the DOM so the active bottle is near the center of the track.
   * Moves nodes from one end to the other without transition.
   */
  function balanceTrack() {
    var all = bottles();
    var half = Math.floor(count / 2);

    // Move bottles so activeIndex ends up at position `half`.
    // Mark relocated bottles so they fade in once positioned.
    while (activeIndex > half) {
      var moved = all.shift();
      moved.classList.add('is-entering');
      track.appendChild(moved);
      activeIndex--;
      all = bottles();
    }
    while (activeIndex < half) {
      var moved = all.pop();
      moved.classList.add('is-entering');
      track.insertBefore(moved, track.firstChild);
      activeIndex++;
      all = bottles();
    }
  }

  function positionTrack(animate) {
    var bw = bottles()[0].offsetWidth;
    // Active bottle is at DOM index `activeIndex`.
    // We want it centered: shift from the track's own center.
    var trackHalf = (count * bw) / 2;
    var bottleCenter = activeIndex * bw + bw / 2;
    var shift = trackHalf - bottleCenter;

    if (!animate) {
      track.style.transition = 'none';
      track.style.transform = 'translateX(calc(-50% + ' + shift + 'px))';
      track.offsetHeight; // force reflow
    } else {
      track.style.transition = 'transform 0.5s ease';
      track.style.transform = 'translateX(calc(-50% + ' + shift + 'px))';
    }
  }

  function updateInfo() {
    var bottle = bottles()[activeIndex];
    if (categoryEl) categoryEl.textContent = bottle.getAttribute('data-category') || '';
    if (titleEl) titleEl.textContent = bottle.getAttribute('data-title') || '';
    if (descriptionEl) descriptionEl.textContent = bottle.getAttribute('data-description') || '';
    if (ctaEl) ctaEl.setAttribute('href', bottle.getAttribute('data-url') || '#');
    if (awardsEl) {
      var raw = bottle.getAttribute('data-awards') || '';
      var urls = raw.split('|').filter(function (u) { return u; });
      awardsEl.innerHTML = urls.map(function (u) {
        return '<img src="' + u + '" alt="" width="40" height="40" loading="lazy">';
      }).join('');
    }
  }

  function updateActive() {
    bottles().forEach(function (b) { b.classList.remove('is-active'); });
    bottles()[activeIndex].classList.add('is-active');
  }

  var animTimeout = null;

  function finishAnimation() {
    if (animTimeout) { clearTimeout(animTimeout); animTimeout = null; }
    isAnimating = false;
    balanceTrack();
    positionTrack(false);
    updateActive();

    // Two rAFs: first commits the layout with opacity:0 + transition:none,
    // second removes the class so the opacity transition kicks in.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var entering = track.querySelectorAll('.ck-spirits__bottle.is-entering');
        for (var i = 0; i < entering.length; i++) {
          entering[i].classList.remove('is-entering');
        }
      });
    });
  }

  function onTransitionEnd(e) {
    if (e.target !== track) return;
    finishAnimation();
  }

  track.addEventListener('transitionend', onTransitionEnd);

  function go(direction) {
    if (isAnimating) return;
    isAnimating = true;

    activeIndex += direction;
    updateActive();
    positionTrack(true);

    if (infoEl) {
      infoEl.classList.add('is-fading');
      setTimeout(function () {
        updateInfo();
        infoEl.classList.remove('is-fading');
      }, 200);
    } else {
      updateInfo();
    }

    // Safety: if transitionend never fires (mobile edge case), unlock after 600ms
    if (animTimeout) clearTimeout(animTimeout);
    animTimeout = setTimeout(finishAnimation, 600);
  }

  // Initial setup
  balanceTrack();
  updateActive();
  positionTrack(false);

  if (prevBtn) {
    prevBtn.addEventListener('click', function () { go(-1); });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () { go(1); });
  }

  // Click on bottle to navigate to it
  bottles().forEach(function (bottle, i) {
    bottle.addEventListener('click', function () {
      if (isAnimating) return;
      var diff = i - activeIndex;
      if (diff !== 0) go(diff);
    });
  });

  // Touch/swipe
  var touchStartX = 0;
  carousel.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  carousel.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      go(diff > 0 ? 1 : -1);
    }
  }, { passive: true });

  window.addEventListener('resize', function () { positionTrack(false); });
})();
